import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { CompaniesService } from 'src/app/services/yardscore-services/companies.service';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';


@Component({
  selector: 'app-companies-list-v2',
  templateUrl: './companies-list-v2.component.html',
  styleUrls: ['./companies-list-v2.component.css']
})
export class CompaniesListV2Component implements OnInit {
  companies: any[] = [];
  searchControl: FormControl = new FormControl();


  constructor(private companiesService: CompaniesService) { }

  ngOnInit(): void {
    this.loadCompanies();

    this.searchControl.valueChanges
      .pipe(
        debounceTime(300),
        distinctUntilChanged()
      )
      .subscribe(searchTerm => {
        this.loadCompanies(searchTerm);
      });
  }

  loadCompanies(search: string = ''): void {
    this.companiesService.getCompaniesV2(search).subscribe(response => {
      this.companies = response.data;
    }, error => {
      console.error('Error fetching companies:', error);
    });
  }
  
  

}
